// ConsoleLogViewer.tsx
import React, { useEffect, useState } from "react";
import { Paper, Stack, Title, Code, ScrollArea } from "@mantine/core";

export const ConsoleLogViewer: React.FC = () => {
  const [logs, setLogs] = useState<string[]>([]);

  useEffect(() => {
    // Original console.log
    const originalLog = console.log;

    // Override för att fånga loggar
    console.log = (...args: any[]) => {
      const message = args
        .map((arg) => {
          if (typeof arg === "object") {
            return JSON.stringify(arg, null, 2);
          }
          return arg;
        })
        .join(" ");
      setLogs((prev) => [...prev, message]);
      originalLog(...args); // Logga ändå till konsol
    };

    // Återställ vid unmount
    return () => {
      console.log = originalLog;
    };
  }, []);

  return (
    <Paper h="100%" w="100%" shadow="sm" p="md" withBorder>
      <Title order={4}>Console Logs</Title>
      <ScrollArea h="calc(100% - 32px)" mt="sm" type="auto" scrollbarSize={8}>
        <Stack gap="xs">
          {logs.length > 0 ? (
            logs.map((log, idx) => (
              <Code key={idx} block>
                {log}
              </Code>
            ))
          ) : (
            <Code>Inga loggar ännu.</Code>
          )}
        </Stack>
      </ScrollArea>
    </Paper>
  );
};
